import { api } from "./api.js";

/**
 * Appointment reminder endpoints.
 *
 * Reminders are persisted server-side (so a sleeping free-tier backend never
 * loses them); the frontend only polls `/due`, fires a native notification and
 * marks each one `sent` to guarantee at-most-once delivery.
 */

/** GET /api/reminders/due — pending reminders whose trigger has passed. */
export const getDue = () => api.get("/reminders/due");

/** PUT /api/reminders/:id/status — body `{ status: 'sent' | 'failed' | 'cancelled' }`. */
export const updateStatus = (id, status) =>
  api.put(`/reminders/${id}/status`, { status });

export default { getDue, updateStatus };
